import { render, staticRenderFns } from "./accountCheckStatus.vue?vue&type=template&id=f7563b86&scoped=true"
import script from "./accountCheckStatus.vue?vue&type=script&lang=js"
export * from "./accountCheckStatus.vue?vue&type=script&lang=js"
import style0 from "./accountCheckStatus.vue?vue&type=style&index=0&id=f7563b86&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7563b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7563b86')) {
      api.createRecord('f7563b86', component.options)
    } else {
      api.reload('f7563b86', component.options)
    }
    module.hot.accept("./accountCheckStatus.vue?vue&type=template&id=f7563b86&scoped=true", function () {
      api.rerender('f7563b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/accountCheckStatus.vue"
export default component.exports